/**************************************************
 * Nombre:       Seccion_Catalogo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import fondo from '../../Recursos/fondo_secciones.svg'
import fondo_peq from '../../Recursos/fondo_secciones_peq.svg'
import Home_Mas_Vendidos from "./Componentes/Home_Mas_Vendidos";
import Home_Oferta_Tiempo from "./Componentes/Home_Oferta_Tiempo";
import Testimonios from "./Componentes/Testimonios";
import Galleria from "./Componentes/Galleria";
import Home_Articulos from "./Componentes/Home_Articulos";
import {SECCIONES} from "../../Constantes";
import Catalogo_Categorias from "./Componentes/Catalogo_Categorias";
import Catalogo_Lista from "./Componentes/Catalogo_Lista";
import {useEffect, useState} from "react";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Catalogo = () => {
    const [catSeleccionada, setCatSeleccionada] = useState({});

    useEffect(() => {
        irArriba()
    },[])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: '#EDFCF6'}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0, zIndex: 1}}>
                <Catalogo_Categorias setCatSeleccionada={setCatSeleccionada}/>
            </Grid>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundImage: `url(${fondo})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    py: 10,
                    mt: -10,
                    zIndex: 2
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                    <Catalogo_Lista categoria={catSeleccionada}/>
                </Grid>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 7, mb: 18}}>
                <Home_Oferta_Tiempo/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundImage: `url(${fondo_peq})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    py: 10,
                    mt: -4,
                    zIndex: 2
                }}
            >

                <Grid id={SECCIONES[1]} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Testimonios/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                    <Galleria/>
                </Grid>


            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 7, mb: 18}}>
                <Home_Articulos/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Catalogo